module.exports = __webpack_public_path__ + "static/media/scaleW-icon.cd481491.svg";